import { __awaiter } from "tslib";
export default class JsonSerializerAdapter {
    constructor(wrappedAdapter) {
        this.wrappedAdapter = wrappedAdapter;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.wrappedAdapter.init();
        });
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.has(contentId);
        });
    }
    set(contentId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.set(contentId, JSON.stringify(content));
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.wrappedAdapter.get(contentId);
            return result && JSON.parse(result);
        });
    }
    getWrappedAdapter() {
        return this.wrappedAdapter;
    }
}
